import emailjs from "@emailjs/browser";

// Forces the browser to download the PDF with a clean, readable filename
// instead of Cloudinary's random public_id.
const buildDownloadUrl = (pdfUrl, fileName) => {
  const cleanName = fileName.replace(/[^a-zA-Z0-9_-]/g, "_"); // strip spaces/special chars
  return pdfUrl.replace("/upload/", `/upload/fl_attachment:${cleanName}/`);
};

export const sendTermsAcceptedEmail = async ({ user, pdfUrl }) => {
  // Prefer verified GST data (structured + trustworthy) for the address block.
  // Fall back to verified Aadhaar data, then to nothing.
  const gst = user?.identityVerification?.gst;
  const aadhaar = user?.identityVerification?.aadhaar;
  const split = gst?.splitAddress;

  let addressLine1 = "";
  let addressLine2 = "";
  let pincode = "";

  if (gst?.verified) {
    addressLine1 = [
      split?.buildingNumber,
      split?.buildingName,
      split?.flatNumber,
    ]
      .filter(Boolean)
      .join(", ");
    addressLine2 = [
      split?.street,
      split?.location,
      split?.city,
      split?.district,
      split?.state,
    ]
      .filter(Boolean)
      .join(", ");
    pincode = split?.pincode || "";
  } else if (gst?.principalAddress) {
    addressLine1 = gst.principalAddress;
  } else if (aadhaar?.verified) {
    addressLine1 = aadhaar.address || "";
    addressLine2 = [aadhaar.district, aadhaar.state].filter(Boolean).join(", ");
    pincode = aadhaar.pincode || "";
  }

  const gstNumber = gst?.gstNumber || user?.GST || "N/A";

  // Build a clean download link for the PDF (fixes the random-filename issue)
  const declarationLink = buildDownloadUrl(
    pdfUrl,
    `PCM_Exports_Declaration_${user.firstName}_${user.lastName}`,
  );

  return emailjs.send(
    process.env.REACT_APP_EMAILJS_SERVICE_ID,
    process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    {
      user_name: `${user.firstName} ${user.lastName}`,
      user_email: user.email,
      accepted_date: new Date().toLocaleString(),
      declaration_link: declarationLink,
      website: "https://www.pcmexports.com",
      year: new Date().getFullYear(),

      proprietor_role: user.designation || "Proprietor",
      company_name: user.companyName || "",
      address_line1: addressLine1,
      address_line2: addressLine2,
      country: user.tag === "International" ? "" : "India",
      pincode,
      gst_number: gstNumber,
    },
    process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
  );
};
